import { toast } from 'sonner';

import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

import { useEventStations } from '../../../../api';
import {
  EventStationResponseItem,
  MutateStationPayload,
  StationsFormValues,
} from '../../../../types';
import { StationForm } from './stations-form';

interface CreateStationDialogProps {
  isOpen: boolean;
  eventId?: string;
  stations?: EventStationResponseItem[];
  onOpenChange: (open: boolean) => void;
}

export function CreateStationDialog({
  isOpen,
  onOpenChange,
  eventId,
  stations,
}: CreateStationDialogProps) {
  const { saveStationsMutation } = useEventStations(eventId, false);

  const saveStations = async (stations: Omit<MutateStationPayload, 'id'>) => {
    try {
      await saveStationsMutation.mutateAsync({
        stations,
      });
      toast.success('Stations updated successfully!');

      onOpenChange(false);
    } catch (error) {
      console.error(error.message);
    }
  };

  const onSubmit = async (formData: StationsFormValues) => {
    await saveStations(formData.stations as unknown as MutateStationPayload);
  };

  return (
    <Dialog onOpenChange={onOpenChange} open={isOpen}>
      <DialogContent className="sm:max-w-[550px]">
        <DialogHeader>
          <DialogTitle>Create station</DialogTitle>
        </DialogHeader>
        <StationForm onSubmit={onSubmit} stations={stations} eventId={eventId}>
          <DialogFooter className="mt-6 gap-4">
            <DialogClose asChild>
              <Button
                variant="outline"
                className="w-[130px]"
                data-testid="cancel-button"
              >
                Cancel
              </Button>
            </DialogClose>
            <Button
              type="submit"
              className="w-[130px]"
              data-testid="save-button"
              isLoading={saveStationsMutation.isPending}
            >
              Save
            </Button>
          </DialogFooter>
        </StationForm>
      </DialogContent>
    </Dialog>
  );
}
